






























































import {
  defineComponent,
  computed,
  ref,
  Ref,
  onUnmounted,
  getCurrentInstance,
  ComponentInternalInstance,
} from '@vue/composition-api';
import { DialogPlugin, DialogInstance } from 'tdesign-vue';
import OrgList from '@/renderer/components/user/components/OrgList.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import { useEggHandler } from '@/renderer/scripts/composition/useEggHandler';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import user from '@/renderer/scripts/utils/user';
import { switchOrg } from '@/renderer/scripts/utils/user/userSwitchOrg';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';

export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    isOauth: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    OrgList,
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const orgList: Ref<SMH.GetUserOrgData> = ref([]);
    const loading = ref(false);
    const switching = ref(false);
    const checkedOrg: Ref<CoFile.OrgItem | null> = ref(null);
    const isTeamExpired = computed(() => vm.$route.name === 'teamExpired');
    const methods = {
      // 获取企业列表
      async getOrgList() {
        try {
          loading.value = true;
          const res = await smh.userAPI.getUserOrg();
          // oauth2授权只展示企业版(未过期、未注销、未冻结的)；筛选放在orgList内部实现
          orgList.value = res.data;
        } catch (e) {
          tips.error(e as MsgError);
        }
        loading.value = false;
      },
      // 选择企业即登录
      chooseOrgLogin(orgInfo: CoFile.OrgItem) {
        if (props.isOauth) {
          context.emit('authorized-org', orgInfo);
          return;
        }
        checkedOrg.value = orgInfo;
        if (switching.value) return;
        if (!checkedOrg.value) return;
        if (checkedOrg.value.isLastSignedIn) {
          if (isTeamExpired.value) {
            tips.error(i18n_t('当前企业已过期，请选择其他企业'));
            return;
          }
          innerShow.value = false;
          return;
        }
        if (checkedOrg.value.ipLimitEnabled) {
          tips.error(i18n_t('当前网络已被管理员设定为不可登录使用，需登录请联系管理员'));
          return;
        }
        switchOrg(checkedOrg.value, () => {
          switching.value = true;
        });
      },
      // 切换完成通知父组件
      afterSwitchOrg() {
        switching.value = false;
        innerShow.value = false;
        tips.success(i18n_t('切换成功'));
        context.emit('after-switch-org');
      },
      // 切换失败
      switchFailed() {
        switching.value = false;
      },
      // 退出登录注销
      signOut() {
        const msg = i18n_t('确定要退出登录吗？');
        const dialog: DialogInstance = CustomDialog.confirm({
          theme: 'warning',
          header: i18n_t('退出登录'),
          body: msg,
          width: '400px',
          async onConfirm() {
            if (dialog.hide) {
              dialog.hide();
            }
            user.signOut();
          },
        });
      },
    };
    methods.getOrgList();
    user.on('switch-org-finished', methods.afterSwitchOrg);
    user.on('switch-org-failed', methods.switchFailed);
    onUnmounted(() => {
      user.off('switch-org-finished', methods.afterSwitchOrg);
      user.off('switch-org-failed', methods.switchFailed);
    });

    // watch(() => vm.$route.name, val => {
    //   closeBtn.value = val !== 'teamExpired';
    // }, { immediate: true });
    // 增加一个重置系统的彩蛋
    const { eggClick } = useEggHandler(10, 'processCrash');
    return {
      innerShow,
      orgList,
      loading,
      switching,
      isTeamExpired,
      eggClick,
      ...methods,
    };
  },
});
